// A job board sends applicants to /welcome?jobId=123&source=indeed. Keep both for the tab so a
// refresh, or a detour through sign-in for someone who already has an account, does not lose
// which job and which board they came from.
const JOB_KEY = 'candidate-web.jobId';
const SOURCE_KEY = 'candidate-web.source';

/** The sources candidate-service records; anything else is a direct sign-up. */
const SOURCES = ['indeed', 'job_board'] as const;
export type ArrivalSource = (typeof SOURCES)[number];

export function captureArrival(params: URLSearchParams): void {
  const rawJob = params.get('jobId');
  if (rawJob != null) {
    const n = Number.parseInt(rawJob, 10);
    if (Number.isInteger(n) && n > 0) window.sessionStorage.setItem(JOB_KEY, String(n));
  }
  const source = toSource(params.get('source'));
  if (source) window.sessionStorage.setItem(SOURCE_KEY, source);
}

export function readJobId(): number | null {
  const raw = window.sessionStorage.getItem(JOB_KEY);
  const n = raw == null ? Number.NaN : Number.parseInt(raw, 10);
  return Number.isInteger(n) && n > 0 ? n : null;
}

export function readSource(): ArrivalSource | null {
  return toSource(window.sessionStorage.getItem(SOURCE_KEY));
}

function toSource(raw: string | null): ArrivalSource | null {
  const v = raw?.trim().toLowerCase();
  return SOURCES.find((s) => s === v) ?? null;
}
